// @ts-nocheck
const config = {
  noSplashScreen: true,
  blackListedURLs: [] as string[],
  development: window.location.hostname === 'localhost',
  env: window.location.hostname === 'localhost' ? 'development' : window.envconferwith.ENV || 'production',
  version: window.envconferwith.VERSION,
  publicApi: {
    enabled: JSON.parse(window.envconferwith.PUBLIC_API_ENABLED || false),
    url: window.envconferwith.PUBLIC_API_URL
  },
  api: { url: window.envconferwith.API_URL },
  expertApi: { enabled: false, url: window.envconferwith.EXPERT_API_URL },
  logger: {
    enabled: JSON.parse(window.envconferwith.LOGGER_ENABLED || false),
    url: window.envconferwith.LOGGER_URL
  },
  contentApi: {
    url: window.envconferwith.CONTENT_API_URL,
    ws: window.envconferwith.CONTENT_API_WS
  },
  productApi: {
    url: window.envconferwith.PRODUCT_API_URL
  },
  opentok: {
    key: window.envconferwith.OPENTOK_KEY
  },
  ipGeoApi: {
    key: window.envconferwith.IPGEO_API_KEY
  },
  inventory: {
    url: window.envconferwith.INVENTORY_URL
  },
  postHog: {
    apiKey: window.envconferwith.POSTHOG_KEY,
    apiHost: window.envconferwith.POSTHOG_HOST
  }
};

export default config;
